import UploadComponent from "../Components/components.upload";
import SearchComponent from "../Components/components.search";
import CustomersComponent from "../Components/components.customers";
import CustomerComponent from "../Components/components.customer";
import PublishReportComponent from "../Components/components.publishreport";
import SearchArticlesComponent from "../Components/components.searcharticles";
import SignupComponent from "../Components/components.signup";
import CartComponent from "../Components/components.cart";
import PricesComponent from "../Components/components.prices";
import PromotionsComponent from "../Components/components.promotions";
import CurrencyService from "../Services/service.currency";
import SearchCustomerComponent from "../Components/components.searchcustomer";
import SearchCartsComponent from "../Components/components.searchcarts";
import UserComponent from "../Components/components.users";
import AffiliateComponent from "../Components/components.affiliates";
import CustomerDiscountsComponent from "../Components/components.customerdiscounts";
import OrdersComponent from "../Components/components.orders";
import ReceiptComponent from "../Components/components.searchreceipt";
import BackorderArticlesComponent from "../Components/components.backorderarticles";
import FixitComponent from "../Components/components.fixit";
import OrderImportComponent from "../Components/components.orderimport";


export default class Base {
    init() {

        const uploadComponent = new UploadComponent();
        uploadComponent.init();

        const searchComponent = new SearchComponent();
        searchComponent.init();

        const customersComponent = new CustomersComponent();
        customersComponent.init();

        const customerComponent = new CustomerComponent();
        customerComponent.init();

        const signupComponent = new SignupComponent();
        signupComponent .init();

        const publishReportComponent = new PublishReportComponent();
        publishReportComponent.init();

        const searchArticlesComponent = new SearchArticlesComponent();
        searchArticlesComponent.init();

        const cartComponent = new CartComponent();
        cartComponent.init();

        const pricesComponent = new PricesComponent();
        pricesComponent.init();

        const promotionsComponent = new PromotionsComponent();
        promotionsComponent.init();

        const searchCustomerComponent = new SearchCustomerComponent();
        searchCustomerComponent.init();

        const searchCartsComponent = new SearchCartsComponent();
        searchCartsComponent.init();

        const usersComponent = new UserComponent();
        usersComponent.init();

        const currencyService = new CurrencyService();
        currencyService.formatNumber();

        const affiliateComponent = new AffiliateComponent();
        affiliateComponent.init();

        const customerdiscountsComponent = new CustomerDiscountsComponent();
        customerdiscountsComponent.init();

        const ordersComponent = new OrdersComponent();
        ordersComponent.init();

        const receiptComponent = new ReceiptComponent();
        receiptComponent.init();

        const backorderArticlesComponent = new BackorderArticlesComponent();
        backorderArticlesComponent.init();

        const fixitComponent = new FixitComponent();
        fixitComponent.init();

        const orderImportComponent = new OrderImportComponent();
        orderImportComponent.init();

        axios.defaults.headers.common['Accept'] = '*/*';
    }
}
